import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CommonService } from '../../../services/common.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

declare var jquery: any;
declare var $: any;

@Component({
    selector: 'app-iban-bic',
    templateUrl: './iban-bic.component.html',
    styleUrls: ['./iban-bic.component.css'],
    standalone: false
})
export class IbanBicComponent implements OnInit {
  @Input() detail;
  @Input() edit: Boolean;
  @Input() add: Boolean;
  @Output() show = new EventEmitter<any>();

  selected = [];
  listIbanBic = [];
  isEmpty: Boolean = true;
  renderTable: Boolean = true;
  default = 0;
  nbdigit;
  classPresta: String = 'detailfact ';
  focusIndex = 0;
  tempClient: any = {};
  selectedRow: any = {};
  error = '';

  @ViewChild('msg') msg;
  @ViewChild('formEdit') formEdit;  
  constructor(public common: CommonService, private modalService: BsModalService) {
  }

  ngOnInit() {
    this.tempClient = Object.assign({}, this.detail);
    this.detail['listeRIB'] = this.detail['listeRIB'] || [];
    this.detail['listeRIB'].forEach(elt => this.listIbanBic.push(Object.assign({}, elt)));
    this.isEmpty = false;
  }

  hide() {
    this.show.emit();
  }

  selectRow(row) {
    this.focusIndex = this.listIbanBic.indexOf(row);
    this.selected = [row];
  }

  deleteLigne(row) {
    const temp = this.listIbanBic.filter(elt => elt !== row);
    this.listIbanBic = temp;
  }

  addLigne() {
    this.listIbanBic.push({
      index: this.listIbanBic.length, id: '1',
    });
    this.listIbanBic = [...this.listIbanBic];
    const length = this.listIbanBic.length - 1;
    setTimeout(function () {
      $('.banque' + (length)).focus();
    }, 600);
  }

  editRow(row) {
    this.selectedRow = Object.assign({}, row);
    const codePays = (this.selectedRow['codePays'] || '').toLowerCase();
    if(this.selectedRow.codePays && this.selectedRow.codePays !="" && codePays !=="fr") {
      this.selectedRow['isCodePaysNonFr'] = true;
    } else {
      this.selectedRow['isCodePaysNonFr'] = false;
    }
  }

  focus(event) {
    const input = event.target;
    const originalValue = $(input).val();
    $(input).val('');
    $(input).blur().focus().val(originalValue);
  }

  update() {
    this.detail['listeRIB'] = this.listIbanBic;
    this.hide();
  }

  verifIban() {
    if(!this.selectedRow.id && this.selectedRow['isCodePaysNonFr']) {
      this.selectedRow['codeBanque'] = "";
      this.selectedRow['codeGuichet'] = "";
      this.selectedRow['clefRIB'] = "";
    }
    const codePays = (this.selectedRow['codePays'] || '').toLowerCase();
    if (codePays === 'fr') {
      this.selectedRow['codeBanque'] = this.selectedRow['codeBanque'] || '';
      this.selectedRow['codeGuichet'] = this.selectedRow['codeGuichet'] || '';
      this.selectedRow['numCompte'] = this.selectedRow['numCompte'] || '';
      if (this.selectedRow['codeBanque'].length !== 5) {
        this.error = `Le code banque doit comporter 5 chiffres.`;
        this.common.openModal(this.modalService, this.msg);
        return false;
      }

      if (this.selectedRow['codeGuichet'].length !== 5) {
        this.error = `Le code guichet doit comporter 5 chiffres.`;
        this.common.openModal(this.modalService, this.msg);
        return false;
      }

      if (this.selectedRow['numCompte'].length !== 11) {
        this.error = `Le num\u00e9ro de compte doit comporter 11 caract\u00e8res.`;
        this.common.openModal(this.modalService, this.msg);
        return false;
      }
      this.verifClefRIBFr();
    } else {
      // this.verifClefIbanNonFr();
      if (this.selectedRow['id']) {
        const temp = [];
        this.listIbanBic.forEach(elt => {
          if (elt.id === this.selectedRow['id']) { elt = this.selectedRow; }
          temp.push(elt);
        });
        this.listIbanBic = temp;
      } else {
        this.listIbanBic.push(this.selectedRow);
        this.listIbanBic = [...this.listIbanBic];
      }
      this.common.closeModal();
      $('.ligneBon').trigger('click');
    }
  }

  verifClefRIBFr() {
    const param = {
      'servlet': 'DBGestionAngular',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 5
        },
        'CODE_BANQUE': this.selectedRow['codeBanque'],
        'CODE_GUICHET': this.selectedRow['codeGuichet'],
        'NUM_COMPTE': this.selectedRow['numCompte'],
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      $('#empty').trigger('click');
      if (this.common.verifySession(datas)) {
        console.log(datas);
        const codeResult = datas.data;
        if (this.selectedRow['clefRIB'] !== codeResult) {
          this.error = `La clef RIB que vous avez saisie ne correspond pas aux
          informations bancaires.\n La clef devrait être : ${codeResult}`;
          this.common.openModal(this.modalService, this.msg);
        } else {
          if (this.selectedRow['id']) {
            const temp = [];
            this.listIbanBic.forEach(elt => {
              if (elt.id === this.selectedRow['id']) { elt = this.selectedRow; }
              temp.push(elt);
            });
            this.listIbanBic = temp;
          } else {
            this.listIbanBic.push(this.selectedRow);
            this.listIbanBic = [...this.listIbanBic];
          }
          this.common.closeModal();
          $('.ligneBon').trigger('click');
        }
      }
    });
  }

  addEtInitialiserLigne() {
      console.log('Calling addEtInitialiserLigne()');
      this.selectedRow = {
          'codeBanque' : '',
          'codeGuichet' : '',
          'numCompte' : '',
          'codePays' : '',
          'clefRIB' : '',
          'isCodePaysNonFr' : false
      }; 
      this.common.openModal(this.modalService, this.formEdit);
  }

  verifClefIbanNonFr() {
    console.log(this.selectedRow);
    const param = {
      'servlet': 'DBGestionAngular',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 6
        },
        'CODE_BANQUE': this.selectedRow['codeBanque'],
        'CODE_GUICHET': this.selectedRow['codeGuichet'],
        'NUM_COMPTE': this.selectedRow['numCompte'],
        'CODE_PAYS': this.selectedRow['codePays'],
        'CLEF_RIB': this.selectedRow['clefRIB']
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      $('#empty').trigger('click');
      if (this.common.verifySession(datas)) {
        console.log(datas);
        const codeResult = datas.data;
        if (this.selectedRow['clefIBAN'] !== codeResult) {
          this.error = `La clef IBAN que vous avez saisie ne correspond pas aux
           informations bancaires.\n La clef devrait être : ${codeResult}`;
          this.common.openModal(this.modalService, this.msg);
        } else {
          if (this.selectedRow['id']) {
            const temp = [];
            this.listIbanBic.forEach(elt => {
              if (elt.id === this.selectedRow['id']) { elt = this.selectedRow; }
              temp.push(elt);
            });
            this.listIbanBic = temp;
          } else {
            this.listIbanBic.push(this.selectedRow);
            this.listIbanBic = [...this.listIbanBic];
          }
          this.common.closeModal();
          $('.ligneBon').trigger('click');
        }
      }
    });
  }
   
  
  onChangeCodePays() {
    const codePays = (this.selectedRow['codePays'] || '').toLowerCase();
    if(this.selectedRow.codePays && this.selectedRow.codePays !="" && codePays !=="fr") {
      this.selectedRow['isCodePaysNonFr'] = true;
    } else {
      this.selectedRow['isCodePaysNonFr'] = false;
    }
  }
}
